(function() {
    var waypoint;
    /* Waypoints sticky header menu */
    if ($('.header.js-header').length) { // No .header on MAPI
        waypoint = new Waypoint({
            element: $('.header.js-header'),
            handler: function(direction) {
                $('body').toggleClass('sticky-nav-on', direction === 'down');
                $('.top-nav-sticky').toggleClass("hide", direction !== 'down');
            },
            offset: function() {
                return -$('.header__content').height();
            }
        });
    }

    if ($('.header.header_skin_life.js-header').length) { // No .header on MAPI
        waypoint = new Waypoint({
            element: $('.header.header_skin_life.js-header'),
            handler: function(direction) {
                $(this.element).toggleClass('header_skin_life--stick', direction === 'down');
            },
            offset: function() {
                return -1;
            }
        });
    }

    function openLeftMenu() {
        $('body').addClass('hamburger-open');
    }

    function closeLeftMenu() {
        $('body').removeClass('hamburger-open');
    }

    function isLeftMenuOpen() {
        return $('body').hasClass('hamburger-open');
    }

    $('.hamburger-open-button').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        openLeftMenu();
    });

    $('.hamburger-close-button').click(closeLeftMenu);

    $('.page-wrapper').on('click', function(e) {
        var $target = $(e.target);
        if (isLeftMenuOpen() && !$target.closest('.left-nav').length) {
            closeLeftMenu();
        }
    });

    $('.nav-editions-open-button').click(function(e) {
        e.preventDefault();

        $('body').addClass('nav-editions-dropdown-open');
    });
    $('.nav-editions-close-button').click(function(e) {
        e.preventDefault();

        $('body').removeClass('nav-editions-dropdown-open');
    });
})();